import type { BlokProps } from "@trydig/storyblok";
import type { RetailersRoute } from "@/data/routes/retailers.route";
import { RetailerListing } from "@/features/retailers/RetailerListing";
import type { BlokRetailerListing } from "@/storyblok";
import BlokWrap from "../BlokWrap";

export const RetailerListingBlok = ({
	blok,
	data,
	preview,
}: BlokProps<BlokRetailerListing, RetailersRoute["list"]>) => {
	return (
		<BlokWrap editable={blok} asChild>
			<RetailerListing blok={blok} preview={preview} data={data} />
		</BlokWrap>
	);
};
